module.exports = __webpack_public_path__ + "static/0018-d484013e0d31c0cbc003bd592e44d013.png";